import { createContext, useContext } from 'react'
import { ShipperRateObjectAugmented } from 'apps/marketplace/utils/hooks/AwardedLanes/useAwardedLanesApi'

export interface IShipperRateContextValue {
  selectedShipperRate?: ShipperRateObjectAugmented
}

export const ShipperRateContext = createContext<IShipperRateContextValue>(
  {} as IShipperRateContextValue
)

export const useShipperRateContext = () => useContext(ShipperRateContext)
